// extracted by mini-css-extract-plugin
var _1 = "DividedContentStyle-module__divided-content___zE5Ty";
var _2 = "DividedContentStyle-module__divided-content-no-vertical-spacing___NwSsS";
var _3 = "DividedContentStyle-module__divided-content___zE5Ty";
var _4 = "DividedContentStyle-module__divided-content-no-vertical-spacing___NwSsS";
export { _1 as "divided-content", _2 as "divided-content-no-vertical-spacing", _3 as "dividedContent", _4 as "dividedContentNoVerticalSpacing" }
